import { GzGeneralDetailsWebComponent } from './component/GzGeneralDetailsWebComponent';

export { GzGeneralDetailsWebComponent };
